import { computed, defineComponent, inject, onMounted, set, useCssModule, useRoute } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { useDuck } from '~/services';
import { useA11y } from '~/composables';
export default defineComponent({
    name: 'BoxArticle',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * Accessibility
         */
        const a11y = useA11y();
        /**
         * Article.
         */
        const article = inject('article');
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Duck service.
         */
        const duck = useDuck();
        /**
         * Route.
         */
        const route = useRoute();
        /**
         * Box Card
         */
        const isCard = computed(() => {
            const { type } = props.box.data || {};
            return type === 'link';
        });
        const isUnique = computed(() => {
            return article.id !== (props.box?.data?.article?.id || props.box?.data?.id);
        });
        const boxArticle = computed(() => {
            return props.box.data?.article;
        });
        const shouldShowGallery = computed(() => {
            if (!boxArticle.value?.gallery) {
                return false;
            }
            if (a11y.isEnabled && !a11y.modes.images.isEnabled) {
                return boxArticle.value?.gallery.every((item) => {
                    const boxes = Array.isArray(item.caption) ? item.caption : item.text || [];
                    return boxes.length > 0;
                });
            }
            return true;
        });
        const fetchArticleTask = useTask(function* () {
            if (!props.box?.data?.id) {
                return;
            }
            const { data } = yield duck.pub.getPubArticleId(props.box.data.id);
            if (!data) {
                return;
            }
            set(props.box.data, 'article', data);
        });
        function handleArticleIntesect() {
            if (boxArticle.value || fetchArticleTask.isRunning) {
                return;
            }
            fetchArticleTask.perform();
        }
        onMounted(() => {
            const { gallery } = route.value.query;
            if (gallery && Number.isInteger(Number(gallery))) {
                fetchArticleTask.perform();
            }
        });
        return {
            article,
            boxArticle,
            css,
            fetchArticleTask,
            handleArticleIntesect,
            isCard,
            isUnique,
            shouldShowGallery,
        };
    },
});
